import React, { FC, ReactNode } from 'react'
import './icon.scss'

export const ExtendedBuyerOverviewHighlighterIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container'>
      <img
        srcSet={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/e2b1e6b67ed9415a0fcb4326eaa8ed08_extendedBuyOverviewIcon1x.png, ' +
          'https://www.static-immobilienscout24.de/statpic/statpic/statpic/sales-journey/hos/rle-wizard/icons/8ea0000076fd3fad75df51e343bb765e_extendedBuyOverviewIcon2x.png 2x, ' +
          'https://www.static-immobilienscout24.de/statpic/statpic/statpic/sales-journey/hos/rle-wizard/icons/fca9b7bc9d8b4203acc6e602a8e1cd6c_extendedBuyOverviewIcon3x.png 3x'
        }
        src={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/e2b1e6b67ed9415a0fcb4326eaa8ed08_extendedBuyOverviewIcon1x.png'
        }
        width={90}
        height={87}
        alt={'Extended overview icon'}
      />
    </div>
  )
}
